import { textColor } from './color';
export var getLegendStyle = function getLegendStyle() {
  return {
    itemWidth: 6,
    itemHeight: 6,
    textStyle: {
      padding: [2, 0, 0, 0]
    }
  };
};
export default {
  textStyle: {
    color: textColor.gray
  }
};